import { Stack } from '@mui/material'
import React from 'react'

import { TestSuiteCompositionTable } from 'components/test-suites/forms/test-suite-composition/TestSuiteCompositionTable'
import { TestSuiteScenarioSelection } from 'components/test-suites/forms/test-suite-composition/TestSuiteScenarioSelection'
import { useTestSuiteFormContext } from 'components/test-suites/forms/TestSuiteFormContext'
import { type Team } from 'types/api/teams'

export const TestSuiteComposition: React.FC<{
  teams: Team[]
}> = ({ teams }) => {
  const { canCreateAndEditTestSuites, isOfficialTestSuite } =
    useTestSuiteFormContext()

  return (
    <Stack spacing={2}>
      {!isOfficialTestSuite && canCreateAndEditTestSuites && (
        <TestSuiteScenarioSelection teams={teams} />
      )}
      <TestSuiteCompositionTable
        canIncludeActions={!isOfficialTestSuite && canCreateAndEditTestSuites}
        teams={teams}
      />
    </Stack>
  )
}
